var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Customize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu-/-Horizontal-Overflow-/-Black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 9.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation-menu-horizontal"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.375,
    cy: 3.023,
    r: 2.625
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 20.625,
    cy: 3.023,
    r: 2.625
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 3.023,
    r: 2.625
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalMenu);
export default __webpack_public_path__ + "static/media/horizontal-menu.8e8337fce738bdf2b74024a760817171.svg";
export { ForwardRef as ReactComponent };